import {
  createFilterFormStore,
  usePersistedFilterFormik,
} from "../../../util/usePersistedFilterFormik";
import { useEffect } from "react";
import { convertToFilter, makeObservable } from "../../../util";
import { createSearchResultNavigationStore } from "../../../util/searchResultNavigation";

// observable store
const shipmentFilterStore = makeObservable({});
const shipmentNavigationStore =
  createSearchResultNavigationStore(shipmentFilterStore);

const toShipmentFilter = values =>
  convertToFilter({
    values,
    filterKeys: ["tab", "_unlocated"],
    skipKeys: ["limit", "offset"],
  });

const filterFormStore = createFilterFormStore(
  "shipments",
  shipmentFilterStore,
  shipmentNavigationStore,
  { toFilter: toShipmentFilter },
);

const useShipmentFilters = () => {
  const formik = usePersistedFilterFormik(
    {
      initialValues: {
        limit: 50,
        offset: 0,
        tab: "items",
        sort1: { operator: "ASC" },
        sort2: { operator: "ASC" },
        sort3: { operator: "ASC" },
      },
    },
    filterFormStore,
  );

  useEffect(() => {
    // convert formik values to filter and update store
    shipmentFilterStore.set(toShipmentFilter(formik.values));
  }, [formik.values]);

  return {
    formik,
  };
};

export { shipmentFilterStore, shipmentNavigationStore, useShipmentFilters };
